/* import __COLOCATED_TEMPLATE__ from './seller-profile-company-internal-notes.hbs'; */
import Component from '@glimmer/component';
import { createCache, getValue } from '@glimmer/tracking/primitives/cache';
import { inject as service } from '@ember/service';
import { action } from '@ember/object';
import { tracked } from '@glimmer/tracking';
import { showModal } from 'sh-www/utils/modal-controls';
import { task } from 'ember-concurrency';
import { handleErrorResponseWithModal } from 'sh-www/utils/handles-errors';

export default class SellerProfileCompanyInternalNotes extends Component {
  @service ('commands.note-commands') noteCommandService;
  @service session;

  @tracked isAddingNewNote = false;
  @tracked newNoteValue = '';

  #userCanSeeNoteProjectLinkMap = createCache(() => {
    const userCanSeeNoteProjectLinkMap = {};
    const currentUser = this.session.currentUser;

    this.args.notes.forEach((note) => {
      // If companyTeams is disabled, can see all assignment links
      userCanSeeNoteProjectLinkMap[note.id] = !this.args.company.canUseCompanyTeams;

      // If note assignment has no companyTeam or user is any admin, user can see
      if (!note.application?.companyTeam || currentUser.isAdmin || currentUser.isCompanyAdmin) {
        userCanSeeNoteProjectLinkMap[note.id] = true;
      }

      // Otherwise, check if user is in note's assignment companyTeam
      else if (this.args.company.canUseCompanyTeams) {
        currentUser.companyTeams.forEach(team => {
          if (note.application.companyTeam.id === team.id) {
            userCanSeeNoteProjectLinkMap[note.id] = true;
          }
        })
      }
    });

    return userCanSeeNoteProjectLinkMap;
  });

  get className() {
    return 'SH-c-seller-profile-freelancer-profile__company-internal-notes';
  }

  get userCanSeeNoteProjectLinkMap() {
    return getValue(this.#userCanSeeNoteProjectLinkMap);
  }

  @task
  *deleteNoteTask(note) {
    try {
      yield this.noteCommandService.deleteNote(note);
      yield this.args.loadProfileNotesTask.perform(this.args.user);
    } catch(error) {
      handleErrorResponseWithModal(this, error);
    }
  }

  @task
  *addNoteTask(newNoteValue) {
    try {
      yield this.noteCommandService.saveNoteOnSubject(this.args.user, this.session.currentUser, newNoteValue);
      yield this.args.loadProfileNotesTask.perform(this.args.user);
    } catch(error) {
      handleErrorResponseWithModal(this, error);
    }
  }

  @action
  handleAddNoteClicked() {
    this.isAddingNewNote = true;
  }

  @action
  handleOnSaveClick() {
    if (this.newNoteValue.length > 0) {
      return this.addNoteTask.perform(this.newNoteValue).then(() => {
        this.newNoteValue = '';
        this.isAddingNewNote = false;
      });
    }
  }

  @action
  handleOnCancelClick() {
    this.isAddingNewNote = false;
  }

  @action
  handleDeleteNoteClick(note) {
    const modalModel = {
      titleText: 'Delete Note?',
      bodyText: `This will permanently remove it from your company's notes on this freelancer`,
      actionButtonText: 'Delete',
      cancelButtonText: 'Cancel',
      isShowCancelButton: true,
      width: 'medium',
      confirmAction: () => {
        this.deleteNoteTask.perform(note);
      }
    };

    showModal(
      this,
      'confirmation',
      modalModel
    );
  }
}
